import * as Yup from 'yup'

export const getValidationSchema = (t) =>
  Yup.object().shape({
    guestCount: Yup.number().min(0, t('clients-legacy:visitCreate.guestCountNegativeError')),
    householdMembersIds: Yup.array().of(Yup.string()),
  })

export function displayUserFullName(user) {
  if (!user) {
    return '-'
  }
  return `${user.firstName} ${user.lastName}`
}
